<template>
    <DashboardContentLayout class="space-y-8" :heading="$t('views.feed.deliveries.header.heading')" :has-period-picker="true" :has-pig-type-picker="true">
        <div class="space-y-8">
            <MainViewCard class="pt-4 pb-2 px-2">
                <GenericChartWithApi :chart-name="chart.name" :height="chart.height" :chart-type="chart.type"></GenericChartWithApi>
            </MainViewCard>
            <MainViewCard>
                <GenericTableWithApi :source="deliveryRegistrationsTableSource" :hidden-headers="hiddenDeliveryRegistrationsHeaders" :hidden-footers="hiddenDeliveryRegistrationsFooters"></GenericTableWithApi>
            </MainViewCard>
            <MainViewCard>
                <GenericTableWithApi :source="deliveryOriginalTableSource"></GenericTableWithApi>
            </MainViewCard>
        </div>
    </DashboardContentLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DashboardContentLayout from '@/components/layouts/dashboardLayout/content/DashboardContentLayout.vue';
import MainViewCard from '@/components/common/MainViewCard.vue';
import GenericTableWithApi from '@/components/common/GenericTableWithApi.vue';
import GenericChartWithApi from '@/components/charts/GenericChartWithApi.vue';
import { Table, Chart, ChartType } from '@/types';
import { store } from '@/plugins/store';

export default defineComponent({
    components: { DashboardContentLayout, MainViewCard, GenericTableWithApi, GenericChartWithApi },
    data() {
        return {
            deliveryRegistrationsTableSource: Table.DeliveryRegistrations,
            deliveryOriginalTableSource: Table.DeliveryOriginal,
            chart: {
                name: Chart.Deliveries,
                type: ChartType.StackedColumnChart,
                height: 220,
            },
        };
    },
    computed: {
        loggedInUserCanReadFeedPrices(): boolean {
            return store.getters.loggedInUserCanReadFeedPrices;
        },
        hiddenDeliveryRegistrationsHeaders(): string[] {
            return this.loggedInUserCanReadFeedPrices ? [] : ['price'];
        },
        hiddenDeliveryRegistrationsFooters(): string[] {
            return this.loggedInUserCanReadFeedPrices ? [] : ['price'];
        },
    },
});
</script>
